import React from 'react';

export default ({ src, backgroundSrc, active, iconStyle, style, ...props }) => {
    const backgroundStyle = backgroundSrc ? { backgroundImage: `url(${backgroundSrc})` } : null;

    return (
        <div className={`circle-icon-button${active ? ' circle-icon-button-active' : ''}`}>
            <div className="circle-icon-button-inner" {...props} style={{ ...backgroundStyle, ...style }}>
                <div className="circle-icon-button-img" style={{ ...iconStyle, backgroundImage: `url(${src})` }} />
            </div>
        </div>
    );
};
